import {
  MONTH_DAY_LABELS,
  TWICE_MONTHLY_LABELS,
  WEEK_DAY_LABELS,
} from "../constants"
import {
  DateStampString,
  MonthDayNumber,
  RepeatableFrequency,
  Schedule,
} from "../types"

export function dateStampStringToLocal(date: DateStampString): string {
  return new Date(date).toLocaleDateString(undefined, { timeZone: "UTC" })
}

export const FREQUENCY_PREFIX_TEXT = {
  monthly: "Monthly on the",
  weekly: "Weekly on",
  every_other_week: "Every other week on",
  twice_monthly: "Twice monthly on the",
}

export function frequencyToSummary(frequency: RepeatableFrequency): {
  prefix: string
  date: string
  starting: string
} {
  const starting = dateStampStringToLocal(frequency.starting)
  switch (frequency.type) {
    case "monthly":
      return {
        prefix: FREQUENCY_PREFIX_TEXT[frequency.type],
        date: MONTH_DAY_LABELS[frequency.day],
        starting,
      }
    case "weekly":
      return {
        prefix: FREQUENCY_PREFIX_TEXT[frequency.type],
        date: WEEK_DAY_LABELS[frequency.weekday],
        starting,
      }
    case "every_other_week":
      return {
        prefix: FREQUENCY_PREFIX_TEXT[frequency.type],
        date: WEEK_DAY_LABELS[frequency.weekday],
        starting,
      }
    case "twice_monthly":
      return {
        prefix: FREQUENCY_PREFIX_TEXT[frequency.type],
        date: TWICE_MONTHLY_LABELS[frequency.days],
        starting,
      }
  }
}

export function frequencyToSchedule(frequency: RepeatableFrequency): Schedule {
  switch (frequency.type) {
    case "monthly":
      return { day_in_month: { day: frequency.day } }
    case "weekly":
      return { weekday: { weekday: frequency.weekday } }
    case "every_other_week":
      return {
        biweekly: {
          start_after: frequency.starting,
          weekday: frequency.weekday,
        },
      }
    case "twice_monthly": {
      // Parse the days string (e.g., "1-15") into two separate day numbers
      const [firstDay, secondDay] = frequency.days
        .split("-")
        .map((day) => parseInt(day, 10) as MonthDayNumber)

      return {
        union: [
          { day_in_month: { day: firstDay } },
          { day_in_month: { day: secondDay } },
        ],
      }
    }
  }
}
